<!--
 * @LastEditors: xionggang
-->
<template>
  <div @click="goBack">
    <slot name="header"></slot>
    <span class="gobackBtn2">
      <img src="@/assets/images/icon/back1.png" class="backimg" alt="">
    </span>
  </div>
</template>

<script>

export default {
  props: {
      className:{
        type: String,
        default: ''
      }
  },
  data () {
    return {
      scroll: ''

    };
  },


  beforeDestroy () {
    window.removeEventListener('scroll', this.handleScroll);
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll () {
      this.scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let top1  = 0;
      try {
        top1  = $('.'+this.className).offset().top;
      } catch (error) {
      }
      let top2 = $(document).scrollTop();
      let top = top1 - top2;
      if (this.scroll-top1>=35) {
        let t1 = 0;
        let t2 = 0;
        let timer2 = null; // 定时器
        document.onscroll = function () {
          clearTimeout(timer2);
          timer2 = setTimeout(isScrollEnd, 300);
          t1 = document.documentElement.scrollTop || document.body.scrollTop;
        }
        function isScrollEnd () {
          t2 = document.documentElement.scrollTop || document.body.scrollTop;
          var path;
          if (t2 == t1) {
            path = require('@/assets/images/icon/back1.png')
            $(".backimg").attr('src', path);
          } else {
            path = require('@/assets/images/icon/back2.png')
            $(".backimg").attr('src', path);
          }
        }
        $('.gobackBtn2').css({ 'display': 'inline-block' })
      } else {
        $('.gobackBtn2').css('display', 'none')
      }
    },
    goBack () {
      this.$emit('goBack');
    }
  }
}
</script>



<style lang="less" scoped>
.gobackBtn2 {
  z-index: 1000;
  display: none;
  position: fixed;
  width: 26px;
  height: 25px;
  top: 10px;
  left: 12px;
  // background-image: url('./../../assets/images/home/back.png');
  // background-size: 100% 100%;
  img {
    width: 26px;
    height: 26px;
  }
}
.gobackBtn {
  width: 0.69333rem;
  position: absolute;
  top: 0.29333rem;
  left: 0.18667rem;
  z-index: 1;
  font-size: 0.53333rem;
  color: #1a1a1a;
}
</style>